import React, { useState, useContext } from "react";
import "../../styles.scss";
import Lottie from "react-lottie";
import MainContext from "../../../../Contexts/MainContext";
import { showToast } from "../../../../Functions";
import { ERROR } from "../../../../Services/Constants";
import api from "../../../../Services/api";
import { INSERT_HORARIOS } from "../../../../Services/Endpoints";

//Animations
const LOADING = require("../../../../Assets/animations/loading.json");
const SUCCESS = require("../../../../Assets/animations/success.json");

const AddSelectedHorario: React.FC = () => {
    const {
        token,
        setaddModalOpen,
        sethasCloseEditModal,
        removehasCloseEditModal,
    } = useContext(MainContext);

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [adicionadoSuccess, setAdicionadoSuccess] = useState(false);
    const [adicionadoError, setAdicionadoError] = useState(false);

    const [nome, setNome] = useState("");
    const [padrao, setPadrao] = useState(false);
    
    const [dias, setDias] = useState([
        { diaDaSemana: "SEGUNDA", nomeFormatado: "Segunda-feira", ativo: true, entrada: "08:00", inicioIntervalo: "12:00", fimIntervalo: "13:30", saida: "18:00" },
        { diaDaSemana: "TERCA", nomeFormatado: "Terça-feira", ativo: true, entrada: "08:00", inicioIntervalo: "12:00", fimIntervalo: "13:30", saida: "18:00" },
        { diaDaSemana: "QUARTA", nomeFormatado: "Quarta-feira", ativo: true, entrada: "08:00", inicioIntervalo: "12:00", fimIntervalo: "13:30", saida: "18:00" },
        { diaDaSemana: "QUINTA", nomeFormatado: "Quinta-feira", ativo: true, entrada: "08:00", inicioIntervalo: "12:00", fimIntervalo: "13:30", saida: "18:00" },
        { diaDaSemana: "SEXTA", nomeFormatado: "Sexta-feira", ativo: true, entrada: "08:00", inicioIntervalo: "12:00", fimIntervalo: "13:30", saida: "18:00" },
        { diaDaSemana: "SABADO", nomeFormatado: "Sábado", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" },
        { diaDaSemana: "DOMINGO", nomeFormatado: "Domingo", ativo: false, entrada: "00:00", inicioIntervalo: "00:00", fimIntervalo: "00:00", saida: "00:00" }
    ]);

    const handleToggleDay = (index: number) => {
        setDias(prev => prev.map((day, idx) => {
            if (idx === index) {
                const newAtivo = !day.ativo;
                return {
                    ...day,
                    ativo: newAtivo,
                    entrada: newAtivo ? "08:00" : "00:00",
                    inicioIntervalo: newAtivo ? "12:00" : "00:00",
                    fimIntervalo: newAtivo ? "13:30" : "00:00",
                    saida: newAtivo ? "18:00" : "00:00"
                };
            }
            return day;
        }));
    };

    const handleTimeChange = (index: number, field: string, value: string) => {
        setDias(prev => prev.map((day, idx) => {
            if (idx === index) {
                return {
                    ...day,
                    [field]: value
                };
            }
            return day;
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!nome.trim()) {
            showToast("ERROR", "Insira o nome da jornada", {});
            return;
        }

        setIsSubmiting(true);

        const newJornada = {
            nome,
            padrao,
            dias: dias.map(({ diaDaSemana, ativo, entrada, inicioIntervalo, fimIntervalo, saida }) => ({
                diaDaSemana,
                ativo,
                entrada,
                inicioIntervalo,
                fimIntervalo,
                saida
            }))
        };

        await api
            .post(INSERT_HORARIOS, newJornada, {
                headers: { Authorization: token },
            })
            .then((resp) => {
                const { status } = resp;

                if (status === 200 || status === 201) {
                    setAdicionadoSuccess(true);

                    window.setTimeout(() => {
                        showToast(
                            "SUCCESS",
                            "Jornada semanal padrão adicionada com sucesso!",
                            {}
                        );

                        sethasCloseEditModal(true);
                        removehasCloseEditModal("closedModal");
                        setaddModalOpen(false);
                    }, 2000);
                }
            })
            .catch((err) => {
                setIsSubmiting(false);
                setAdicionadoError(true);
                showToast("ERROR", `${err.message}`, {});
            });
    };

    return (
        <div className="selected__wrapper" style={{ maxWidth: '800px', width: '100%', margin: '0 auto' }}>
            {!isSubmiting ? (
                <form onSubmit={handleSubmit}>
                    <h3 className="tt-sub title-blue title-bold" style={{ marginBottom: '20px' }}>
                        Novo Modelo de Jornada Semanal
                    </h3>
                    
                    <div className="form__group not__centered" style={{ width: '100%' }}>
                        <label htmlFor="nome-jornada">Nome da Jornada</label>
                        <input
                            id="nome-jornada"
                            type="text"
                            placeholder="Ex: Jornada Administrativa 44h"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                            style={{ borderRadius: '8px', padding: '12px' }}
                        />
                    </div>

                    <div style={{ marginTop: '20px', marginBottom: '25px' }}>
                        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>Configuração dos Dias</label>
                        
                        {dias.map((day, idx) => (
                            <div key={day.diaDaSemana} className={`jornada-day-row ${!day.ativo ? 'disabled' : ''}`}>
                                <div className="day-label">{day.nomeFormatado}</div>
                                <div className="day-toggle">
                                    <label className="toggle-switch">
                                        <input
                                            type="checkbox"
                                            checked={day.ativo}
                                            onChange={() => handleToggleDay(idx)}
                                        />
                                        <span className="slider"></span>
                                    </label>
                                </div>
                                <div className="day-times">
                                    <div className="time-input-group">
                                        <label>Entrada</label>
                                        <input
                                            type="time"
                                            value={day.entrada}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "entrada", e.target.value)}
                                        />
                                    </div>
                                    <div className="time-input-group">
                                        <label>Ini. Intervalo</label>
                                        <input
                                            type="time"
                                            value={day.inicioIntervalo}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "inicioIntervalo", e.target.value)}
                                        />
                                    </div>
                                    <div className="time-input-group">
                                        <label>Fin. Intervalo</label>
                                        <input
                                            type="time"
                                            value={day.fimIntervalo}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "fimIntervalo", e.target.value)}
                                        />
                                    </div>
                                    <div className="time-input-group">
                                        <label>Saída</label>
                                        <input
                                            type="time"
                                            value={day.saida}
                                            disabled={!day.ativo}
                                            onChange={(e) => handleTimeChange(idx, "saida", e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="form__group not__centered form__flex" style={{ width: '100%', justifyContent: 'flex-start', gap: '10px' }}>
                        <input
                            id="padrao-checkbox"
                            type="checkbox"
                            checked={padrao}
                            onChange={(e) => setPadrao(e.target.checked)}
                            style={{ width: 'auto', flex: 'none' }}
                        />
                        <label htmlFor="padrao-checkbox" style={{ margin: 0, flex: 'none', cursor: 'pointer' }}>
                            Definir como Padrão do Sistema
                        </label>
                    </div>

                    <div className="form__group not__centered" style={{ width: '100%', marginTop: '30px' }}>
                        <button
                            type="submit"
                            className="bt"
                            style={{ margin: '0 auto', width: '100%', maxWidth: '250px', background: '#6366f1', border: 'none', borderRadius: '8px', padding: '12px' }}
                        >
                            Salvar Jornada
                        </button>
                    </div>
                </form>
            ) : (
                <Lottie
                    options={{
                        loop: !adicionadoSuccess ? true : false,
                        animationData:
                            !adicionadoSuccess && !adicionadoError
                                ? LOADING
                                : adicionadoSuccess
                                ? SUCCESS
                                : ERROR,
                    }}
                    height={105}
                    width={105}
                />
            )}
        </div>
    );
};
export default AddSelectedHorario;
